// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type TubeRuleValidateFieldsQueryVariables = Types.Exact<{
  input: Types.RuleValidateInput;
  productInput: Types.ConfiguratorProductUserInput;
}>;


export type TubeRuleValidateFieldsQuery = { __typename?: 'Query', getTubeRuleValidateFields: { __typename?: 'TubeRuleValidateResponse', listFiveMod?: Array<string> | null, listThreeMod?: Array<string> | null, listScale?: Array<string> | null, listPurification?: Array<string> | null, listModification?: Array<string> | null, listFormat?: Array<string> | null, listConcentration?: Array<string> | null, listTubes?: Array<string> | null, listMinimumYield?: number | null, listAmount?: Array<string> | null, listPurityLevel?: Array<string> | null, listNterminalMod?: Array<string> | null, listCterminalMod?: Array<string> | null, listQuantitation?: Array<string> | null, listInternalMod?: Array<string> | null, baseCount?: number | null, molecularWeight?: string | null, primerDimer?: string | null, meltingTemperature?: string | null, secondaryStructure?: string | null, gcContent?: string | null, listLabeledAminoAcids?: Array<string | null> | null, listConjugation?: Array<string> | null, listConjugationAmount?: Array<string> | null, listConjugationChemistry?: Array<string> | null, listAdditionalCarrierProtein?: Array<string> | null, listServices?: Array<string> | null, listAdditionalServices?: Array<string> | null, additionalServices?: Array<string> | null, sequence?: string | null, isLNABaseEnable?: boolean | null, antisenceName?: string | null, antisenseBaseCount?: string | null, antisenseMolecularWeight?: string | null, antisensePrimerDimer?: string | null, antisenseMeltingTemperature?: string | null, antisenseGcContent?: string | null, antisenseSecondaryStructure?: string | null, listErrors?: Array<{ __typename?: 'TubeListError', key: string, value: string }> | null, listWarnings?: Array<{ __typename?: 'ListWarning', key?: string | null, value?: string | null }> | null, serverError?: { __typename?: 'ListError', key?: string | null, value?: string | null } | null } };


export const TubeRuleValidateFieldsDocument = gql`
    query tubeRuleValidateFields($input: RuleValidateInput!, $productInput: ConfiguratorProductUserInput!) {
  getTubeRuleValidateFields(input: $input, productInput: $productInput) {
    listErrors {
      key
      value
    }
    listWarnings {
      key
      value
    }
    listFiveMod
    listThreeMod
    listScale
    listPurification
    listModification
    listFormat
    listConcentration
    listTubes
    listMinimumYield
    listAmount
    listPurityLevel
    listNterminalMod
    listCterminalMod
    listQuantitation
    listInternalMod
    baseCount
    molecularWeight
    primerDimer
    meltingTemperature
    secondaryStructure
    gcContent
    listLabeledAminoAcids
    listConjugation
    listConjugationAmount
    listConjugationChemistry
    listAdditionalCarrierProtein
    listServices
    listAdditionalServices
    additionalServices
    sequence
    isLNABaseEnable
    antisenceName
    antisenseBaseCount
    antisenseMolecularWeight
    antisensePrimerDimer
    antisenseMeltingTemperature
    antisenseGcContent
    antisenseSecondaryStructure
    serverError {
      key
      value
    }
  }
}
    `;
export type TubeRuleValidateFieldsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TubeRuleValidateFieldsQuery, TubeRuleValidateFieldsQueryVariables>, 'query'> & ({ variables: TubeRuleValidateFieldsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TubeRuleValidateFieldsComponent = (props: TubeRuleValidateFieldsComponentProps) => (
      <ApolloReactComponents.Query<TubeRuleValidateFieldsQuery, TubeRuleValidateFieldsQueryVariables> query={TubeRuleValidateFieldsDocument} {...props} />
    );
    

/**
 * __useTubeRuleValidateFieldsQuery__
 *
 * To run a query within a React component, call `useTubeRuleValidateFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTubeRuleValidateFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTubeRuleValidateFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      productInput: // value for 'productInput'
 *   },
 * });
 */
export function useTubeRuleValidateFieldsQuery(baseOptions: Apollo.QueryHookOptions<TubeRuleValidateFieldsQuery, TubeRuleValidateFieldsQueryVariables> & ({ variables: TubeRuleValidateFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TubeRuleValidateFieldsQuery, TubeRuleValidateFieldsQueryVariables>(TubeRuleValidateFieldsDocument, options);
      }
export function useTubeRuleValidateFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TubeRuleValidateFieldsQuery, TubeRuleValidateFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TubeRuleValidateFieldsQuery, TubeRuleValidateFieldsQueryVariables>(TubeRuleValidateFieldsDocument, options);
        }
export function useTubeRuleValidateFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TubeRuleValidateFieldsQuery, TubeRuleValidateFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TubeRuleValidateFieldsQuery, TubeRuleValidateFieldsQueryVariables>(TubeRuleValidateFieldsDocument, options);
        }
export type TubeRuleValidateFieldsQueryHookResult = ReturnType<typeof useTubeRuleValidateFieldsQuery>;
export type TubeRuleValidateFieldsLazyQueryHookResult = ReturnType<typeof useTubeRuleValidateFieldsLazyQuery>;
export type TubeRuleValidateFieldsSuspenseQueryHookResult = ReturnType<typeof useTubeRuleValidateFieldsSuspenseQuery>;
export type TubeRuleValidateFieldsQueryResult = Apollo.QueryResult<TubeRuleValidateFieldsQuery, TubeRuleValidateFieldsQueryVariables>;